<template>
  <div class="container">
    <thead>
      <tr>
        <th scope="col" colspan="2">{{ encabezado }}</th>
        <th scope="col">{{ Yeartwo }}</th>
        <th scope="col">{{ YearOne }}</th>
        <th scope="col">{{ varEntorno }}</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <th scope="row" colspan="2">
          Tiene Política de Gestión de Personas formalizada vía Resolución (Sí /
          No)
        </th>
        <td>
          <input
            :disabled="readOnly"
            class="input"
            v-model="politicaGestion.inputOne"
          />
        </td>
        <td>
          <input
            :disabled="readOnly"
            class="input"
            v-model="politicaGestion.inputTwo"
          />
        </td>
        <td>
          <input
            :disabled="readOnly"
            v-model="politicaGestion.inputThree"
            class="input"
          />
        </td>
      </tr>
    </tbody>
  </div>
</template>

<script>
// import store from "../../../../../../store";
export default {
  props: ["politicaGestion", "readOnly"],
  data() {
    return {
      encabezado: "Variables",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",

      text: "Tiene sistema de retroalimentación implementado (Sí / No)",
    };
  },
  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
  },
  updated() {
    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       text:this.text,
    //       anio_two: this.inputOne,
    //       anio_one: this.inputTwo,
    //       anio: this.inputThree,
    //     },
    //   ],
    //   nameTable: "politicaGestion",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}

td {
  text-align: center !important;
}
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 90%;
  padding: 5px;
}
.input {
  margin-right: 10px;
}
</style>
